export default {
  ADVERTISER_NOT_WHITELISTED_FOR_USING_UPLOADED_DATA: `Your Adwords account is <a href="https://support.google.com/adspolicy/answer/6299717" target="_blank" rel="noopener noreferrer">not whitelisted for uploading custom user lists</a>. Get in touch with your Google account manager to correct this.`,
  NAME_ALREADY_USED: 'Your Adwords account already has a custom audience with this name. Change the name and try again',
};
